import React from 'react';
import './skills.css';
import useScrollReveal from '../../hooks/useScrollReveal';

const skillsData = [
    {
        icon: 'devicon-javascript-plain colored',
        name: 'JavaScript',
        desc: 'Interactive front-end features, DOM manipulation, async patterns, and modern ES6+ tooling.',
        level: 85,
        colorClass: 'js',
    },
    {
        icon: 'devicon-react-original colored',
        name: 'React',
        desc: 'Component-driven UIs with hooks, state management, context API, and React Router.',
        level: 80,
        colorClass: 'react',
    },
    {
        icon: 'devicon-html5-plain colored',
        name: 'HTML5',
        desc: 'Semantic markup, accessibility best practices, SEO-friendly structure, and forms.',
        level: 90,
        colorClass: 'html',
    },
    {
        icon: 'devicon-css3-plain colored',
        name: 'CSS3',
        desc: 'Modern layouts with Flexbox & Grid, animations, responsive design, and CSS variables.',
        level: 85,
        colorClass: 'css',
    },
    {
        icon: 'devicon-git-plain colored',
        name: 'Git',
        desc: 'Version control, branching strategies, rebasing, and team collaboration workflows.',
        level: 90,
        colorClass: 'git',
    },
    {
        icon: 'devicon-github-original colored',
        name: 'GitHub',
        desc: 'Pull requests, code review, CI/CD integrations, and open-source repo management.',
        level: 85,
        colorClass: 'github',
    },
    {
        icon: 'devicon-php-plain colored',
        name: 'PHP',
        desc: 'Server-side scripting, REST APIs, MVC patterns, and backend template engines.',
        level: 65,
        colorClass: 'php',
    },
    {
        icon: 'devicon-python-plain colored',
        name: 'Python',
        desc: 'Scripting, automation, web scraping, security tools, and backend API services.',
        level: 80,
        colorClass: 'python',
    },
    {
        icon: 'devicon-mysql-plain colored',
        name: 'MySQL',
        desc: 'Database design, complex queries, indexing, and relational data management.',
        level: 75,
        colorClass: 'mysql',
    },
    {
        icon: 'devicon-linux-plain colored',
        name: 'Kali / Linux',
        desc: 'Penetration testing tools, shell scripting, system administration, and network analysis.',
        level: 70,
        colorClass: 'kali',
    },
];

function Skills() {
    const sectionRef = useScrollReveal();

    return (
        <div className="skills-container" id="Skills" ref={sectionRef}>
            <link
                rel="stylesheet"
                type="text/css"
                href="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/devicon.min.css"
            />
            <h2 className="scroll-reveal">
                My <span className="highlight-gradient">Skills</span>
            </h2>
            <p className="skills-subtitle scroll-reveal delay-1">
                Technologies and tools I work with every day
            </p>

            <div className="skills-grid">
                {skillsData.map((skill, index) => (
                    <div
                        className={`skill-card scroll-reveal delay-${(index % 4) + 1}`}
                        key={skill.name}
                    >
                        <i className={`${skill.icon} skill-icon`} aria-hidden="true"></i>
                        <h3>{skill.name}</h3>
                        <p>{skill.desc}</p>
                        <div className="skill-bar" aria-hidden>
                            <div
                                className={`skill-level ${skill.colorClass}`}
                                style={{ '--skill-width': `${skill.level}%` }}
                            ></div>
                        </div>
                        <span className="skill-percent">{skill.level}%</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Skills;